import styled from 'styled-components';

export const SliderContainer = styled.div`
  margin-top: 45px;

  .slick-slide > div {
    display: flex;
    height: 100%;
  }

  .slick-dots li button {
    width: 16px;
    height: 16px;
    padding: 0;
  }

  .slick-dots li button:before {
    font-size: 16px;
    color: #d8d8d8;
  }

  /* Active dot */
  .slick-dots li.slick-active button:before {
    color: #8cc4b8;
  }

  .slick-slider {
    margin-bottom: 24px; /* or whatever space you want */
  }

  .slick-dots {
    bottom: -45px;
  }
`;
